import { BaseHeader } from '@components/page/header';
import { StyledRenderedAILogo } from './StyledRenderedAILogo';

export const TransitionScreen = () => {
  return (
    <div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column' }}>
      <BaseHeader />
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <StyledRenderedAILogo color="white" />
      </div>
    </div>
  );
};
